/* ============================================================
   FITCNT Theme — JavaScript
   ============================================================ */

(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Cart count helper ────────────────────────────────────
  function setCartCount(count) {
    var el = document.getElementById('cart-count');
    if (!el) return;
    el.textContent = count;
    el.classList.toggle('is-hidden', !count);
    var icon = el.closest('.cart-icon');
    if (icon) {
      icon.setAttribute(
        'aria-label',
        count ? 'Cart, ' + count + ' item' + (count === 1 ? '' : 's') : 'Cart'
      );
    }
  }

  // Initialise hidden state on load
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.getElementById('cart-count');
    if (el) {
      var n = parseInt(el.textContent, 10) || 0;
      setCartCount(n);
    }
  });

  // ── Email Capture Popup ──────────────────────────────────
  var popup        = document.getElementById('email-popup');
  var popupClose   = document.getElementById('popupClose');
  var popupOverlay = document.getElementById('popupOverlay');
  var popupForm    = document.getElementById('popupForm');

  if (popup) {
    var STORAGE_KEY = 'fitcnt_popup_dismissed';

    function openPopup() {
      popup.removeAttribute('hidden');
      popup.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      var emailInput = document.getElementById('popupEmail');
      if (emailInput) emailInput.focus();
    }

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('hidden', '');
      document.body.style.overflow = '';
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }

    var dismissed = false;
    try { dismissed = !!localStorage.getItem(STORAGE_KEY); } catch (e) {}

    // Don't show inside the Shopify theme editor preview
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    if (!dismissed && !inEditor) {
      // Defer until idle, then wait 4s — keeps initial load fast
      var schedule = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1); };
      schedule(function () { setTimeout(openPopup, 4000); });
    }

    if (popupClose)   popupClose.addEventListener('click', closePopup);
    if (popupOverlay) popupOverlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) closePopup();
    });

    if (popupForm) {
      var showPopupSuccess = function (email) {
        popupForm.style.display = 'none';
        var sub = popup.querySelector('.popup-sub');
        if (sub) sub.style.display = 'none';

        var existingSuccess = popup.querySelector('.popup-success');
        if (existingSuccess) existingSuccess.remove();

        var success = document.createElement('div');
        success.className = 'popup-success show';
        var icon = document.createElement('div');
        icon.className = 'popup-success-icon';
        icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>';
        var h3 = document.createElement('h3');
        h3.textContent = "You're In!";

        var welcomeCode = popupForm.getAttribute('data-welcome-code');

        success.appendChild(icon);
        success.appendChild(h3);

        if (welcomeCode) {
          // Show the code instantly
          var p1 = document.createElement('p');
          p1.textContent = 'Here’s your 10% welcome code:';
          success.appendChild(p1);

          var codeEl = document.createElement('button');
          codeEl.type = 'button';
          codeEl.className = 'popup-code';
          codeEl.textContent = welcomeCode;
          codeEl.setAttribute('aria-label', 'Copy discount code ' + welcomeCode);
          codeEl.style.cursor = 'pointer';
          codeEl.addEventListener('click', function () {
            var copy = navigator.clipboard && navigator.clipboard.writeText
              ? navigator.clipboard.writeText(welcomeCode)
              : Promise.reject();
            copy.then(function () {
              codeEl.textContent = 'Copied!';
              setTimeout(function () { codeEl.textContent = welcomeCode; }, 1600);
            }).catch(function () {});
          });
          success.appendChild(codeEl);

          var p2 = document.createElement('p');
          p2.style.cssText = 'font-size:12px;color:#555;margin-top:8px;';
          p2.textContent = 'Tap to copy · valid on one-time purchases, one use per customer.';
          success.appendChild(p2);
        } else {
          var p1b = document.createElement('p');
          p1b.appendChild(document.createTextNode('Check your inbox at '));
          var strong = document.createElement('strong');
          strong.textContent = email;
          p1b.appendChild(strong);
          success.appendChild(p1b);

          var p2b = document.createElement('p');
          p2b.style.cssText = 'font-size:12px;color:#555;';
          p2b.textContent = 'Your welcome offer is on its way.';
          success.appendChild(p2b);
        }

        popupForm.parentNode.insertBefore(success, popupForm.nextSibling);

        try { localStorage.setItem(STORAGE_KEY, '1'); } catch (err) {}
        // Leave the popup open longer when a code is displayed so it can be copied
        setTimeout(closePopup, welcomeCode ? 20000 : 5000);
      };

      var showPopupError = function (msg) {
        var err = popup.querySelector('.popup-error');
        if (!err) {
          err = document.createElement('p');
          err.className = 'popup-error';
          err.style.cssText = 'color:#E31919;font-size:13px;font-weight:600;margin-top:10px;';
          popupForm.parentNode.insertBefore(err, popupForm.nextSibling);
        }
        err.textContent = msg;
      };

      popupForm.addEventListener('submit', function (e) {
        var emailInput = document.getElementById('popupEmail');
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) return;

        var hasExternalHandler = popupForm.hasAttribute('action') || popupForm.classList.contains('klaviyo-form');
        if (hasExternalHandler) {
          try { localStorage.setItem(STORAGE_KEY, '1'); } catch (err) {}
          return;
        }

        e.preventDefault();

        // ── Klaviyo client subscription (configured in Theme settings → Email Capture) ──
        var company = popupForm.getAttribute('data-klaviyo-company');
        var list = popupForm.getAttribute('data-klaviyo-list');

        if (company && list) {
          var submitBtn = popupForm.querySelector('.popup-submit');
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Joining…'; }

          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2024-10-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Website welcome popup',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email: email }
                    }
                  }
                },
                relationships: {
                  list: { data: { type: 'list', id: list } }
                }
              }
            })
          }).then(function (res) {
            if (res.ok || res.status === 202) {
              showPopupSuccess(email);
            } else {
              return res.text().then(function () {
                showPopupError('Something went wrong — please try again.');
                if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Get My Offer'; }
              });
            }
          }).catch(function () {
            showPopupError('Connection issue — please try again.');
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Get My Offer'; }
          });
          return;
        }

        // No Klaviyo configured — show success UI only (no data is sent anywhere)
        showPopupSuccess(email);
      });
    }
  }

  // ── Desktop dropdown accessibility ──────────────────────
  document.querySelectorAll('.nav-item-has-dropdown').forEach(function (item) {
    var trigger = item.querySelector('a[aria-haspopup="true"]');
    if (!trigger) return;

    function setExpanded(value) {
      trigger.setAttribute('aria-expanded', value ? 'true' : 'false');
    }

    item.addEventListener('mouseenter', function () { setExpanded(true); });
    item.addEventListener('mouseleave', function () { setExpanded(false); });
    item.addEventListener('focusin', function () { setExpanded(true); });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) setExpanded(false);
    });
  });

  // ── Hero Entrance Animation ──────────────────────────────
  function initHeroAnimation(root) {
    var els = (root || document).querySelectorAll('.hero-animate');
    if (!els.length) return;

    if (prefersReducedMotion || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('hero-entered'); });
      return;
    }

    var delays = [100, 300, 500, 700, 900, 1100];
    els.forEach(function (el) {
      var step = parseInt(el.dataset.delay, 10) || 0;
      var ms   = delays[step] !== undefined ? delays[step] : (100 + step * 200);
      setTimeout(function () { el.classList.add('hero-entered'); }, ms);
    });
  }

  initHeroAnimation();
  document.addEventListener('shopify:section:load', function (e) {
    initHeroAnimation(e.target);
  });

  // ── Mobile Menu ──────────────────────────────────────────
  var menuToggle = document.getElementById('mobileMenuToggle');
  var mobileNav  = document.getElementById('mobileNav');

  if (menuToggle && mobileNav) {
    function closeMobileNav() {
      mobileNav.classList.remove('open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    menuToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) closeMobileNav();
    });

    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMobileNav);
    });
  }

  // ── Sticky Header Scroll Behaviour ───────────────────────
  var header = document.querySelector('.site-header');
  if (header) {
    var ticking = false;
    function updateHeader() {
      header.classList.toggle('is-scrolled', window.scrollY > 80);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
    updateHeader();
  }

  // ── Add to Cart — AJAX ────────────────────────────────────
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      e.preventDefault();

      var originalText = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.innerHTML = '<span class="btn-spinner" aria-hidden="true"></span> Adding…';

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          setCartCount(cart.item_count);
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          btn.innerHTML = '✓ Added';
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-success');
            btn.innerHTML = originalText;
          }, 1800);
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.innerHTML = originalText;
        });
    });
  });

  // ── Smooth scroll for anchor links ───────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    var href = anchor.getAttribute('href');
    if (!href || href === '#' || href.length < 2) return;
    anchor.addEventListener('click', function (e) {
      var target;
      try { target = document.querySelector(href); } catch (err) { return; }
      if (!target) return;
      e.preventDefault();
      var headerEl = document.querySelector('.site-header');
      var headerHeight = headerEl ? headerEl.offsetHeight : 80;
      var top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
      window.scrollTo({
        top: top,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    });
  });

  // ── Scroll reveal animations ───────────────────────────────
  function initScrollAnimations(root) {
    var scope = root || document;
    var isHome = document.body.classList.contains('template-index');
    var selectors = isHome ? [
      '.trust-item',
      '.bundle-text',
      '.bundle-meta span',
      '.bundle-price-row',
      '.bundle-cta-row',
      '.bundle-products',
      '.featured-products-header',
      '.product-card',
      '.why-section-header',
      '.why-card',
      '.reviews-header',
      '.review-aggregate',
      '.review-card'
    ] : [
      '.product-card',
      '.why-card',
      '.review-card',
      '.trust-item',
      '.bundle-inner'
    ];
    var fadeTargets = scope.querySelectorAll(selectors.join(', '));

    if (fadeTargets.length) {
      fadeTargets.forEach(function (el, index) {
        el.classList.add('fade-in-up');
        el.style.setProperty('--reveal-delay', ((index % 6) * 85) + 'ms');
      });

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        fadeTargets.forEach(function (el) { el.classList.add('is-visible'); });
      } else {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });

        fadeTargets.forEach(function (el) { observer.observe(el); });
      }
    }

    if (isHome) {
      var openingSections = [];
      if (scope.matches && scope.matches('.featured-products')) openingSections.push(scope);
      scope.querySelectorAll('.featured-products').forEach(function (section) {
        if (openingSections.indexOf(section) === -1) openingSections.push(section);
      });

      if (openingSections.length) {
        if (prefersReducedMotion || !('IntersectionObserver' in window)) {
          openingSections.forEach(function (section) { section.classList.add('section-open'); });
          return;
        }

        openingSections.forEach(function (section) { section.classList.add('section-anim-ready'); });

        var sectionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('section-open');
              sectionObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.22, rootMargin: '0px 0px -12% 0px' });

        openingSections.forEach(function (section) { sectionObserver.observe(section); });
      }
    }
  }

  initScrollAnimations();
  document.addEventListener('shopify:section:load', function (e) {
    initScrollAnimations(e.target);
  });

})();

/* ============================================================
   FYNALFLOW — Carousel arrows (benefit cards / ingredients)
   ============================================================ */
(function () {
  'use strict';

  function initCarousels(scope) {
    scope = scope || document;
    scope.querySelectorAll('.bc-track-wrap').forEach(function (wrap) {
      if (wrap.dataset.carouselInit) return;
      wrap.dataset.carouselInit = '1';

      var track = wrap.querySelector('[data-carousel-track]');
      var prev = wrap.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]');
      if (!track) return;

      function step() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 16 : 320;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  initCarousels();
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();

/* ============================================================
   Clickable comparison-table columns (data-url cells)
   ============================================================ */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var cell = e.target.closest('.ct-table [data-url]');
    if (!cell) return;
    if (e.target.closest('a')) return; // header anchor handles itself
    window.location.href = cell.getAttribute('data-url');
  });
})();
